<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link
                :to="{ path: '/setup/property-definition' }"
                class="vx-row"
              >
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("Create Property Master") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Code')"
              >
                <vs-input
                  :label="$t('setup.label.Code')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="code"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Description')"
              >
                <vs-input
                  :label="$t('setup.label.Description')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="description"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.PropertyCodeType")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.PropertyCodeType')"
                >
                  <v-select
                    label="mCodeValue"
                    :options="propertyMasterTemplateData"
                    :reduce="(obj) => obj.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    v-model="propertyCodeType"
                  >
                    <template v-slot:option="option">
                      {{ option.mCodeValue }}
                    </template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.ReferenceValue')"
              >
                <vs-input
                  :label="$t('setup.label.ReferenceValue')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="referenceValue"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
          <vs-button @click="handleSubmit" class="mr-3 mb-2 footerButton-next">
            {{ $t("setup.label.Submit") }}
          </vs-button>
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";

export default {
  data() {
    return {
      propertyCodeType: "",
      code: "",
      description: "",
      referenceValue: "",
      errorMessage: "",
      warningPopup: false,
      warningText: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      propertyMasterTemplateData: (state) =>
        state.propertyDefinition.propertyMasterTemplate,
    }),
  },
  methods: {
    resetForm() {
      this.propertyCodeType = "";
      this.code = "";
      this.description = "";
      this.referenceValue = "";
      this.$refs.observer.reset();
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const payload = {
        propertyCodeType: this.propertyCodeType,
        code: this.code,
        description: this.description,
        referenceValue: this.referenceValue,
      };
      try {
        await this.$store.dispatch(
          "propertyDefinition/createPropertyMasterAction",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Property Master Created Successfully!",
          type: "success",
        });
        this.$router.push("/setup/property-definition");
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getPropertyMasterTemplateMethod() {
      try {
        await this.$store.dispatch(
          "propertyDefinition/getPropertyMasterTemplateAction"
        );
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
  },

  async mounted() {
    await this.getPropertyMasterTemplateMethod();
  },
};
</script>
